import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { CacheService, ICurrencyBO } from '@mapfre-tech/amap3';
import { Observable, throwError } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import * as _ from 'lodash';

@Injectable({
   providedIn: "root"
})
export class CurrencyService {

   className = 'CurrencyService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllCurrencies(cache = true, cacheKey = "allCurrencies"): Observable<ICurrencyBO[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ICurrencyBO[]>;
       } else {
         const observable = this.http.get<ICurrencyBO[]>(environment.base_URL + "/currencies").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newCurrency(currency: ICurrencyBO) {
      return this.http.post<ICurrencyBO>(environment.base_URL + "/currencies", currency).pipe(tap(() => this.deleteCache()))
   }

   updateCurrency(currency: ICurrencyBO, id: number) {
      return this.http.put<ICurrencyBO>(environment.base_URL + `/currencies/${id}`, currency).pipe(tap(() => this.deleteCache()))
   }

   deleteCurrency(id: number) {
      return this.http.delete(environment.base_URL + `/currencies/${id}`).pipe(tap(() => this.deleteCache()))
   }

   deleteCache() {
      this.cacheService.deleteCache('allCurrencies');
   }
}
